import { Vehicle, VehicleLocation } from 'server'
import { inTexas } from '../plotting'

export const defaultVehicleFilter = (
  vehicle: Vehicle,
  vehicleLocation: VehicleLocation,
  texasMask = false
): boolean => {
  if (!vehicleLocation) {
    return false
  }

  // Remove vehicles with name containing 'GR'
  if (vehicle.vehicle_category_id === 2 && vehicle.name.includes('GR')) {
    return false
  }

  if (texasMask) {
    if (!inTexas(vehicleLocation)) {
      return false
    }
  }
  return true
}
